/**
 * jv.common.responsive
 *
 * Depends on `ngStorage`.
 *
 * Provides `responsiveSession` service for setting session storage to enable/disable responsive.
 * Enabled by default unless explicitly disabled.
 *
 * Provides `jv-responsive` directive that will add `mobile` class to html tag if it's enabled.
 * Used in conjunction with mobile styles in `common/_mobile.scss`.
 *
 * Provides `jv-disable-responsive` directive to set session var and remove class on touchend of element.
 *
 * Provides `jv-reponsive-menu` to control visibility of mobile dropdown.
 */

angular.module('jv.common.responsive', [
    (function(){
        if (typeof require === 'function') {
            require('../../lib/ngStorage/ngStorage.min.js');
        }
        return 'ngStorage';
    })()
])
.service('responsiveSession', [
    '$sessionStorage', '$timeout',
    function($sessionStorage, $timeout) {
        // timeouts needed to persist localStorage
        this.enable = function() {
            $timeout(function() {
                delete $sessionStorage.disableResponsive;
            });
        };
        this.disable = function() {
            $timeout(function() {
                $sessionStorage.disableResponsive = true;
            });
        };
        this.isEnabled = function() {
            return !$sessionStorage.disableResponsive;
        };
    }
])
.directive('jvResponsive', [
    'responsiveSession',
    function(responsiveSession) {
        return {
            link: function() {
                if (responsiveSession.isEnabled()) {
                    angular.element('html').addClass('mobile');
                }
            }
        };
    }
])
.directive('jvDisableResponsive', [
    'responsiveSession',
    function(responsiveSession) {
        return {
            link: function($scope, element) {
                element[0].addEventListener('touchend', function() {
                    responsiveSession.disable();
                    angular.element('html').removeClass('mobile');
                });
            }
        };
    }
])
.directive('jvResponsiveMenu', [
    function() {
        return {
            link: function($scope, element, attrs) {
                var trigger = document.querySelector(attrs.jvResponsiveMenu);
                trigger.addEventListener('touchend', function(event) {
                    event.preventDefault();
                    element.removeClass('ng-hide');
                });
                document.body.addEventListener('touchstart', function(event) {
                    if (!element[0].contains(event.target) && event.target !== trigger) {
                        element.addClass('ng-hide');
                    }
                });
            }
        };
    }
])
.directive('jvResponsiveLogout', [
    function() {
        return {
            link: function($scope, element, attrs) {
                element[0].addEventListener('touchend', function(event) {
                    event.preventDefault();
                    angular.element('<form action="' + attrs.jvResponsiveLogout + '" method="post"></form>')
                        .appendTo('body')
                        .submit();
                });
            }
        };
    }
]);